import { useMemo } from 'react';
import type { PropsWithChildren } from 'react';

import { AuthBaseUrlContextProvider } from '@opendoor/auth-fe/context';

import { getAthenaClient } from '../api';
import { COSMOS_URL } from '../globals';
import { fromGraphqlRequestClient } from './fromGraphqlRequestClient';

const AuthProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const client = useMemo(() => fromGraphqlRequestClient(getAthenaClient()), []);
  return (
    <AuthBaseUrlContextProvider authBaseUrl={COSMOS_URL} client={client}>
      {children}
    </AuthBaseUrlContextProvider>
  );
};

export default AuthProvider;
